import axios from 'axios';
import apiUrl from '../../constants';

export function getClientData(token){
  return axios({
    method: 'post',
    url: apiUrl.api_url + 'getClientList',
    data: {},
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
  }


// WEBPACK FOOTER //
// ./src/services/B2BModule/getClientData.js